/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Empty_Epics_BodyInputs */

const en_tl_empty_epics_body = /** @type {(inputs: Tl_Empty_Epics_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No epic or initiative matches this view. Show every dated item, or plan by milestone.`)
};

const de_tl_empty_epics_body = /** @type {(inputs: Tl_Empty_Epics_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Epic und keine Initiative passt zu dieser Ansicht. Zeig alle Vorgänge mit Terminen oder plane nach Meilenstein.`)
};

/**
* | output |
* | --- |
* | "No epic or initiative matches this view. Show every dated item, or plan by milestone." |
*
* @param {Tl_Empty_Epics_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_empty_epics_body = /** @type {((inputs?: Tl_Empty_Epics_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Empty_Epics_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_empty_epics_body(inputs)
	return en_tl_empty_epics_body(inputs)
});